/**
 * Chart Type
 */
export var ChartType;
(function (ChartType) {
    ChartType["List"] = "list";
    ChartType["Table"] = "table";
    ChartType["Line"] = "line";
    ChartType["Bar"] = "bar";
    ChartType["Column"] = "column";
    ChartType["Pie"] = "pie";
    ChartType["Counter"] = "counter";
})(ChartType || (ChartType = {}));
